<div class="loading-wrapper">
    <div class="loading">
        <doka-spinner [size]="spinnerSize"></doka-spinner>
    </div>
</div>